// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7bd536b9","703":"d1c2e5b2","787":"22edae46"}[chunkId] + ".chunk.js";
};